<template>
    <BasePanel :alvqa="alvqa" headline="lang_PUBLISHING_WORKS_CAPTION_INSRUMENTATION" :helpContext="getHelpContext">
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                :items="listItems"
                :items-per-page="1000"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
                <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.title.toLowerCase() + '-text-title'">
                        {{ showInstrumentationTitle(item.title) }}
                    </div>
                </template>
                <template v-slot:[`item.instruments`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() +'-text-instruments'" class="text-right">
                        {{ item.instruments }}
                    </div>
                </template>
                <template v-slot:[`item.musicians`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() +'-text-musicians'" class="text-right">
                        {{ item.musicians }}
                    </div>
                </template>
                <template v-slot:[`item.voices`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-'+ item.title.toLowerCase() +'-text-voices'" class="text-right">
                        {{ item.voices }}
                    </div>
                </template>
                <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name:"InstrumentationEditPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'publishing-works-edit-form-panel-instrumentation'
        }
    },
    computed: {
        getHelpContext() {
            return 'PublishingWorksEditPanelInstrumentation'
        },
        listItems() { 
            return this.$store.getters.getWorksInstrumentation 
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_ITEM_TITLE"), 
                    align: "left", 
                    value: "title",
                    sortable: false,
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_INSTRUMENTS"), 
                    align: "right", 
                    value: "instruments",
                    sortable: false,
                    alvqa: this.alvqa + '-header-instruments'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_MUSICIANS"), 
                    align: "right", 
                    value: "musicians",
                    sortable: false,
                    alvqa: this.alvqa + '-header-musicians'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_VOICES"), 
                    align: "right", 
                    value: "voices",
                    sortable: false,
                    alvqa: this.alvqa + '-header-voices'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    width: "70px",
                    class: 'text-no-wrap'
                },
               {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    class: 'text-no-wrap'
                }
            ]
        },
        
    },
        methods: {

        addNewRow(){
            this.$store.commit('setShowWorksInstrumentationEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultWorksInstrumentation)) 
            this.$store.commit('setWorksInstrumentationEditingDialogDetails', defaultValues)
        },

        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog

            this.$store.commit("setSelectedWorksInstrumentation", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedWorksInstrumentation')
            this.$store.commit('setShowDeletionDialog', true)
        },

        editInlineFunction(item) {
            this.$store.commit('setSelectedWorksInstrumentation', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // set the copy in dialog details to edit
            this.$store.commit('setWorksInstrumentationEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowWorksInstrumentationEditingDialog', true) 
        },
        showInstrumentationTitle(title){
            let instrumentationList = this.$store.getters.getInstrumentations[this.$i18n.locale]
            if(instrumentationList === undefined) {
                instrumentationList = this.$store.getters.getInstrumentations['en']
            }
            
            let match = instrumentationList.find(instrument => {
                    return instrument.value === title
            })
            return match.text
        }
    },
    created() {
        this.$store.commit('setInstrumentations')
    },
    
}
</script>